import { Seq } from 'immutable'
export default function stubImmutableSeq() {
  return Seq([])
}
